module.exports = __webpack_public_path__ + "img/cny.5bb0dfef.svg";